/** Parse client contact lines from order/lead notes (mirrors backend). */
export type CrmParsedContact = {
  name: string | null;
  phone: string | null;
  company: string | null;
};

export function parseLeadTitle(title: string | null | undefined): { name: string; company: string | null } {
  const t = (title || '').trim();
  if (!t) return { name: '', company: null };
  for (const sep of [' — ', ' – ', ' - ']) {
    if (t.includes(sep)) {
      const [left, right] = t.split(sep);
      return { name: left.trim(), company: right.trim() || null };
    }
  }
  return { name: t, company: null };
}

export function parseContactFromNotes(notes: string | null | undefined): CrmParsedContact {
  const out: CrmParsedContact = { name: null, phone: null, company: null };
  if (!notes) return out;
  for (const raw of notes.split('\n')) {
    const line = raw.trim();
    if (!line) continue;
    const lower = line.toLowerCase();
    if (lower.startsWith('контакт:') || lower.startsWith('фио:')) {
      out.name = line.split(':').slice(1).join(':').trim() || null;
    } else if (lower.startsWith('компания:')) {
      out.company = line.split(':').slice(1).join(':').trim() || null;
    } else if (lower.startsWith('тел.') || lower.startsWith('телефон:') || lower.startsWith('тел:')) {
      out.phone = line.split(':').slice(1).join(':').trim() || null;
    }
  }
  return out;
}

export type CrmPipelineContactInput = {
  user: {
    first_name?: string | null;
    username?: string | null;
    phone?: string | null;
    company?: string | null;
  };
  notes?: string | null;
  client_contact?: {
    name?: string;
    phone?: string | null;
    company?: string | null;
    telegram_id?: number | null;
    username?: string | null;
  };
};

export function resolvePipelineContact(
  card: CrmPipelineContactInput,
): CrmParsedContact & { displayName: string } {
  const fromApi = card.client_contact;
  if (fromApi?.name) {
    return {
      name: fromApi.name,
      phone: fromApi.phone ?? card.user.phone ?? null,
      company: fromApi.company ?? card.user.company ?? null,
      displayName: fromApi.name,
    };
  }
  const fromNotes = parseContactFromNotes(card.notes);
  const fromTitle = parseLeadTitle(card.user.first_name);
  const name =
    fromNotes.name || fromTitle.name || card.user.first_name || card.user.username || 'Клиент';
  const company = fromNotes.company || fromTitle.company || card.user.company || null;
  const phone = fromNotes.phone || card.user.phone || null;
  return { name, phone, company, displayName: name };
}
